import type { CSSProperties } from "react";
import { Text } from "../../typography";
import { classNames } from "../../utils/classNames";
import type { ComparisonSide } from "./comparison";

type ScheduleLabelChipProps = {
	label: string;
	side?: ComparisonSide;
	size?: "xs" | "sm";
	className?: string;
	style?: CSSProperties;
};

export const ScheduleLabelChip = ({ label, side, size = "sm", className, style }: ScheduleLabelChipProps) => {
	const muted = side === "before";
	return (
		<div
			className={classNames(
				"flex items-center justify-center rounded-md",
				muted ? "bg-neutral-faded" : "bg-accent-faded",
				className,
			)}
			style={style}
		>
			<Text
				size={size}
				weight="medium"
				intent={muted ? "muted" : undefined}
				className={muted ? undefined : "text-accent"}
			>
				{label}
			</Text>
		</div>
	);
};
